(ns app.front.view.group.admin.fees.payment.payment-subs
  (:require [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub
  ::online-payment-method
  :<- [::entities/entities {:entity/type         :entity.type/payment-method
                            :payment-method/type :payment-method/online-card}]
  (fn [payment-methods [_ auth-group-id]]
    (->> payment-methods
         (filter #(= (:db/id (:domain/authority-group %)) auth-group-id))
         first)))


(rf/reg-sub
  ::payment-instructions
  :<- [::entities/context]
  (fn [ctx [_ authority-group-id]]
    (-> (entities/find-entity ctx authority-group-id)
        :payment/instructions
        str)))


(rf/reg-sub
  ::payment-details
  :<- [::entities/entities {:entity/type :entity.type/payment-detail}]
  (fn [payment-details [_ authority-group-id]]
    (->> payment-details
         (filter #(= (:db/id (:domain/authority-group %)) authority-group-id))
         (sort-by :payment-detail/name))))
